import { Firebase, organizationId } from './../util';

import store from '../store';

export function AppConfigRef(){
  return Firebase.firestore().doc(`appConfig/v0`);
}

export function LocalizationsRef(){
  return Firebase.firestore().collection(`appConfig/v0/localizations`);
}

export function OrgConfigRef(){
  return Firebase.firestore().collection(`orgConfig`);
}

export function AssessmentVersionsRef(){
  return Firebase.firestore().collection(`assessmentVersions`);
}

export function AssessmentConfigsRef(){
  return Firebase.firestore().collection(`assessmentConfigs`);
}

export function AssessmentsRef(){
  return Firebase.firestore().collection(`assessments`);
}
export function ScoredAssessmentsRef(){
  return Firebase.firestore().collection(`scoredAssessments`);
}

export function OrganizationsRef(){
  return Firebase.firestore().collection(`organizations`);
}

export function OrganizationScoredAssessmentsRef(){
  return Firebase.firestore().collection(`organizations/${organizationId()}/scoredAssessments`);
}

export function OrganizationRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`);
}

export function OrganizationExportsRef(){
  return Firebase.firestore().collection(`organizations/${organizationId()}/exports`);
}

export function PublicUsersRef(){
  return Firebase.firestore().collection('users');
}

export function UsersRef(){
  return OrganizationRef().collection('users');
}

export function TeamsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('teams');
}

export function AccountsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('accounts');
}

export function SprintHistoryRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('sprintHistory');
}
export function CurrentSprintsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('currentSprints');
}

export function TalentEvaluationsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('talentEvaluations');
}

export function SalesCompetencyReviewItemsRevi(){
  return Firebase.firestore().doc(`salesCompetencyReviewItems/0.1`);
}

export function SalesCompetencyReviewsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('salesCompetencyReviews');
}

export function FeedbackRef(){
  return Firebase.firestore().collection('feedback');
}

export function DealsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('deals');
}
export function DealSnapshotsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('dealSnapshots');
}



// WEBPACK FOOTER //
// ./src/util/refs.js